import { modelServices } from '@/app/shared/services/client-agent-service.js';
import { httpClient } from '@/app/shared/services/http-client/http-client.js';

export class ManufacturingOrderService {
    getManufacturingOrders() {
        return modelServices.baseUrl + modelServices.getInventoryManagementOdataServiceName("getManufacturingOrderList").URL;
    }
    InitAddManufacturingOrder(callback) {
        var url = modelServices.baseUrl + modelServices.getInventoryManagementServiceName("InitializeAddManufacturingOrder").URL;
        return httpClient.get(url).then(callback);
    }
    FillLocationByProductAndWarehouse(productID, warehouseID,callback) {
        var url = modelServices.baseUrl + modelServices.getInventoryManagementServiceName("FillLocationByProductAndWarehouse").URL + "?productID=" + productID + "&warehouseID=" + warehouseID;
        return httpClient.get(url).then(callback);
    }

    getProductRawMaterials(producedProductModel, callback) {
        var url = modelServices.baseUrl + modelServices.getInventoryManagementServiceName("getProductRawMaterials").URL;
        const options = {
            url: url,
            method: 'POST',
            data: JSON.stringify(producedProductModel)
        };
        httpClient(options).then(callback);
    }
    addManufacturingOrder(ManufacturingOrderModel, callback) {
        var url = modelServices.baseUrl + modelServices.getInventoryManagementServiceName("addManufacturingOrder").URL;
        const options = {
            url: url,
            method: 'POST',
            data: JSON.stringify(ManufacturingOrderModel)
        };
        httpClient(options).then(callback);
    }
    viewManufacturingOrder(id,callback) {
        var url = modelServices.baseUrl + modelServices.getInventoryManagementServiceName("viewManufacturingOrder").URL + "?manufacturingOrderID=" + id;
        return httpClient.get(url).then(callback);
    }
}

const manufacturingOrderService = new ManufacturingOrderService();
export { manufacturingOrderService };